module.exports = __webpack_public_path__ + "img/shark-new-year.fcb912a5.svg";